export default __webpack_public_path__ + "roboto-v27-latin-700.0682ca7f74351d42bf73ed1e95572bfe.woff2";